import { CSSProperties, DragEvent, useEffect, useRef } from "react"

/* Protopia Ecosystem component */
export interface IRotateHandlerProps {
   style: CSSProperties
   onDragStart:(evt: DragEvent) => void
   onDrag:(evt: DragEvent) => void
   onDragEnd:(evt: DragEvent) => void
}
const RotateHandler = (props: IRotateHandlerProps): JSX.Element => {
    const ref = useRef(null)
    useEffect(() => {
        const shifter = (ref.current! as any)  
        shifter.addEventListener("dragstart", props.onDragStart) 
        shifter.addEventListener("drag", props.onDrag) 
        shifter.addEventListener("dragend", props.onDragEnd) 
        return () => {
            shifter.removeEventListener("dragstart", props.onDragStart) 
            shifter.removeEventListener("drag", props.onDrag) 
            shifter.removeEventListener("dragend", props.onDragEnd) 
        }
    }, [])
    return <div className='rotate-handler' style={props.style} draggable ref={ref}>
        <svg 
            xmlns="http://www.w3.org/2000/svg" 
            xmlnsXlink="http://www.w3.org/1999/xlink" 
            x="0px" 
            y="0px"
            width="30px"
            height="30px"
            viewBox="0 0 576 596.4" 
            xmlSpace="preserve"
        > 
            <circle className="st0" cx="380.7" cy="223.7" r="33.4"/>
            <polygon  className="st1" points="441.4,480.3 562.7,472.5 506,537 "/>
            <polygon  className="st1" points="106.7,145.6 114.5,24.3 50,81 "/>
            <path className="st1" d="M294.1,134.1c-12.1-7.3-24.5-14.2-37.3-20.4c-48-23.5-99.4-38.5-152.6-44.6l-9.9-1.1l-3.4,29.8l9.9,1.1
                c62.7,7.2,121.7,28,174,59.2C280.2,149.4,286.7,141.3,294.1,134.1z"/>
            <path className="st1"  d="M517.9,482.8c-6.1-53.2-21.1-104.6-44.6-152.6c-2.4-4.9-4.9-9.7-7.4-14.4c-7.5,7-15.9,13-25,18
                c24.6,46.7,41,98.2,47.2,152.5l1.1,9.9l29.8-3.4L517.9,482.8z"/>
            <path d="M381,261c-20.4,0-37-16.6-37-37s16.6-37,37-37s37,16.6,37,37S401.4,261,381,261z M381,193.9c-16.6,0-30.1,13.5-30.1,30.1
	            s13.5,30.1,30.1,30.1s30.1-13.5,30.1-30.1S397.6,193.9,381,193.9z"/>
        </svg>
    </div>
}
export default RotateHandler